var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.2797V13.2797C15.0015 13.6552 14.8447 14.0138 14.568 14.2676C14.2914 14.5215 13.9205 14.6469 13.5466 14.6131C11.4952 14.3902 9.52463 13.6892 7.79329 12.5664C6.18251 11.5428 4.81685 10.1772 3.79329 8.56641C2.66661 6.82721 1.96546 4.84707 1.74663 2.78641C1.71294 2.41365 1.83747 2.04391 2.0898 1.76749C2.34213 1.49107 2.69902 1.33343 3.07329 1.33307H5.07329C5.74254 1.32649 6.31296 1.81705 6.40663 2.47974C6.49104 3.11978 6.64759 3.74822 6.87329 4.35307C7.05645 4.84032 6.9393 5.38961 6.57329 5.75974L5.72663 6.60641C6.67566 8.27544 8.0576 9.65737 9.72663 10.6064L10.5733 9.75974C10.9434 9.39373 11.4927 9.27658 11.98 9.45974C12.5848 9.68544 13.2132 9.84199 13.8533 9.92641C14.5237 10.021 15.0168 10.6029 15 11.2797Z",
    stroke: "var(--color-pi-navy-blue)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNo);
export default __webpack_public_path__ + "static/media/contactNo.bad2948be4e984815a2acc19caaa278f.svg";
export { ForwardRef as ReactComponent };